<template>
	<div class="main-contents">
		<div class="package">
			<div class="table">
				<!-- 인터뷰 요청 -->
				<div class="list-box">
					<fixTop :inContent="true" fixClass="top-fix">
						<template v-slot:conts>
							<div class="bt-list mt-10">
								<img src="/images/admin/list_shortcut.png" alt="목록가기"  @click="$router.go(-1)">
							</div>

							<span v-if="interviewReqList.length > 0">
								<div class="itv-result-box" v-for="row in interviewReqList" :key="row.projectSeq">
									<div class="prj_ct">
										<div class="mark-box">
											<div class="mark pf" v-if="row.projectStatus == '1'">수행중</div>
											<div class="mark cp" v-else-if="row.projectStatus == '9'">완료</div>
											<div class="mark ep" v-else>수행예정</div>
											<div v-if="row.recrEndDateDiff >= 0" class="mark rc">모집중</div>
											<div class="regDate">등록일자<span style="margin-left: 10px;">{{row.regDate | date('yyyy.MM.dd')}}</span></div>
										</div>
										<div class="flex sp-tw">
											<div class="prj_outline">
												<div class="top">
													<div class="outline">
														<div class="value prj prj-tit-hover" @click="clickProjectInfo(row.projectSeq, row.projectStatus)">{{row.projectNm}}</div>
													</div>
													
													<div class="outline">
														<div class="label">
															<p>고 객 사</p>
														</div>
														<div style="display: inline-flex; width: 750px;">
															<div class="prj_outline_clientname">
																{{row.clientNm}}
															</div>
															<div class="prj_outline_clientloc">
																<img src="/images/location.png" alt="위치" />{{row.projectLocCont}}
															</div>
														</div>
													</div>
												</div>
												
												<div class="outline">
													<div class="label">
														<p>수 행 사</p>
													</div>
													<div class="value">{{row.corpNm}}</div>
												</div>
												<div class="outline">
													<div class="label">
														<p>개 발 기 간</p>
													</div>
													<div class="value">{{row.projectStartYyyymmdd | date('yyyy.MM.dd')}} - {{row.projectEndYyyymmdd | date('yyyy.MM.dd')}}</div>
												</div>
												<div class="outline">
													<div class="label">
														<p>직 무 분 야</p>
													</div>
													<div class="value">
														<ul class="duty-list">
															<li v-for="(duty, index) in row.dutyList" :key="index">
																<span>
																	<SelectComp type="text_comma_split" cdId="PRO141" :value="duty.dutyFilterCd"/>/<SelectComp type="text_comma_split" cdId="PRO142" :value="duty.dutyFieldCd"/>
																</span>
															</li>
														</ul>
													</div>
												</div>
												<div class="outline">
													<div class="label">
														<p>개 발 기 술</p>
													</div>
													<div class="value text">{{row.devTechCont}}</div>
												</div> 
												
											</div>

											<!--고객CI/지원자정보-->
											<div class="client_info">
												<div class="deadline">
													<div>
														<span class="date" v-if="row.recrEndDateDiff >= 0">
															<img class="period" src="/images/tec/prj/date_color.png" alt="마감기간"/> 
															마감 <span class="period">{{row.recrEndDateDiff}}</span>일 전
														</span>
													</div>
													<div>
														<span>
															<img class="member" src="/images/tec/prj/member_sm.png" alt="합격IT프로"/> 
															합격 <span class="member">{{row.interview04Cnt}}</span>명
														</span>
													</div>
												</div>
											</div>	
										</div>
									</div>

									<div style="padding: 20px;">
										<!-- 요청한 인터뷰 결과가 있을 경우 -->
										<div v-if="row.intvReqPersonList.length > 0" class="Board type3" style="margin-top: 0;">
											<table class="Board_type3 human itv">
												<colgroup>
													<col width="3%">
													<col width="10%">
													<col width="10%">
													<col width="7%">
													<col width="16%">
													<col width="8%">
													<col width="15%">
													<col width="12%">
													<col width="*">
												</colgroup>
												<thead>
													<tr>
														<th>NO</th>
														<th>지원분야</th>
														<th>인터뷰 결과</th>
														<th>평가등급</th>
														<th>IT프로명</th>
														<th>기술등급</th>
														<th>경력</th>
														<th>학력-졸업</th>
														<th>직무</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(intvRow, rIdx) in row.intvReqPersonList" :key="rIdx" @click="profileOpen(intvRow, rIdx)" :class="tecMberSeq == intvRow.mberSeq && seletedIndex == rIdx ? 'click' : '' ">	
														<td class="score">{{(pageInfo.pageIndex - 1) * pageInfo.pageUnit + (rIdx + 1)}}</td>
														<!-- <td class="score">{{intvRow.rn}}</td> -->
														<td class="score">{{intvRow.workCont}}</td>
														<td class="score">
															<gradeImg type="INTERVIEW_RES" :grade="intvRow.statusImg" />
															<img class="change" src="/images/itv_change.png" alt="교체화살표" v-if="intvRow.rn == undefined && intvRow.statusImg == '00'"/>
															<p class="result ivl11" v-if="intvRow.statusImg == '00'">합격</p>
															<p class="result" v-if="intvRow.statusImg == '01'">불 합 격</p>
															<img class="change" src="/images/itv_change.png" alt="교체화살표" v-if="intvRow.statusImg == '02'"/>
															<p class="result change" v-if="intvRow.statusImg == '02'">교체투입</p>
															<p class="result in" v-if="intvRow.statusImg == '03'">인터뷰중</p>
														</td>
														<td class="score">
															<div class="gradeimg">
																<grade-img type="TOT_SM_EVAL" :grade="intvRow.totEvalGrade" :specialYn="intvRow.specialGradeYn">
																	<template v-slot:smark><div class="s-mark"><img src="/images/admin/s-mark.png" alt="스페셜마크"></div></template>
																</grade-img>
															</div>
														</td>
														<td class="score">{{intvRow.mberNm}} ({{intvRow.gender}})</td>
														<td class="score">{{intvRow.techGradeNm}}</td>
														<td class="score">{{intvRow.totWorkMonthCnt | months}}</td>
														<td class="score"><SelectComp type="text" :value="intvRow.schoolDivCd" cdId="PRO121"/></td>
														<td class="score"><span class="duty">{{intvRow.duty}}</span></td>
													</tr>
												</tbody>
											</table>
											<!-- 페이징부분 -->
											<pagingComp :pageInfo="pageInfo" @page-click="goPage" :classNm="'mb-0'"/>
										</div>

										<!-- 인터뷰 인원이 없을 경우 -->
										<div v-else class="project_box tech-intv-none">
											<div>
												인터뷰 인원이 없습니다.
											</div>
										</div>
									</div>
								</div>
							</span>

						</template>
					</fixTop>

					<!-- footer -->
					<!-- <footer-layout type="left"/> -->
				</div>

				<!-- 상세보기 -->
				<!-- <tec-profile :tecMberSeq="tecMberSeq" v-model="detailObj" @update="selectIntvReqList()" @profileClose="profileClose()"/> -->
			</div>
		</div>
	</div>
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';
import gradeImg from '@/components/highpro/GradeImg.vue';
// import tecProfile from "@/components/highpro/TecProfile.vue";
// import footerLayout from "@/components/layout/footer.vue";
import fixTop from "@/components/FixTop.vue";

export default {
	data() {
		return {
			interviewReqList : [],
			pageInfo : {
				pageIndex : 1,
				pageUnit : 15,
				pageSize : 10
			},

			corpdiv : this.$store.state.userInfo.mberDivCd,
			
			srcFilter : {
				// pageIndex : '1',
				ordCol : '1',
				// srcTxt : this.$route.params.projectNm || '',
			},

			tecMberSeq : '',
			seletedIndex : 0,
			detailObj : {},

			nowYyyymmdd : new Date().format("yyyyMMdd"),
			
		}
	},

	components : {
		gradeImg, fixTop, pagingComp
	},

	beforeMount() {
		this.selectIntvReqList();
	},

	mounted(){
        // this.$emit('setViewConfig', {'footer': 'left', 'quickMenu':false})
    },
    destroyed(){
        this.$emit('clearViewConfig')
    },

	methods : {
		selectIntvReqList(div) {
			var param = this.srcFilter;
			
			param.corpdiv = this.corpdiv;
			param.projectSeq = this.$route.params.projectSeq != undefined ? this.$route.params.projectSeq : '';

			param.pageUnit = this.pageInfo.pageUnit;
			param.pageSize = this.pageInfo.pageSize;
			param.pageIndex = this.pageInfo.pageIndex;
			
			if(div) param.pageIndex = div;

			this.$.httpPost('/api/prj/prj/selectInterviewReqList', param)
				.then((res) => {
					// console.log('RESULT :', res);

					this.interviewReqList = res.data.interviewReqList;

					if(this.tecMberSeq) this.tecMberSeq = '';

					for(var i in this.interviewReqList){
						this.pageInfo = res.data.interviewReqList[i].pageInfo;
						if(this.interviewReqList[i].dutyFieldCont){
							var tempArr = this.interviewReqList[i].dutyFieldCont.split(',');
							this.interviewReqList[i].dutyList = [];

							for(var j in tempArr){
								this.interviewReqList[i].dutyList.push({dutyFilterCd : tempArr[j].substr(0,2),
																   dutyFieldCd  : tempArr[j]});
							}
						}

					}
				})
		},

		orderSort(div) {
			this.srcFilter.ordCol = div;
			this.selectIntvReqList();
		},

		// 페이지 이동
		goPage(page) {
			this.pageInfo.pageIndex = page;
			this.selectIntvReqList();
		},

		// IT프로 상세 열기
		profileOpen(intvRow, rIdx){
			if(this.corpdiv == '31' && intvRow.mberInfoYn == 'N'){ // 파트너사 > IT프로의 소속사가 변경된 경우 상세정보 조회불가
				this.profileClose();
				alert("소속이 변경된 IT프로입니다.");
			}else{
				// this.tecMberSeq = intvRow.mberSeq; 
				this.seletedIndex = rIdx;
				if(this.corpdiv == '31') {
					this.$router.push({name : 'SRH401M02', params : { tecMberSeq : intvRow.mberSeq }});
				} else {
					this.$router.push({name : 'SRH301M02', params : { tecMberSeq : intvRow.mberSeq }});
				}
				
			}
		},

		// IT프로 상세 닫기
		profileClose() {
			this.tecMberSeq = '';
			this.detailObj = {};
		},

		// 프로젝트 상세보기 팝업
		clickProjectInfo(projectSeq, projectRecrStatus) {
			var param = {
				projectSeq : projectSeq,
				projectRecrStatus : projectRecrStatus
			};
			this.$.popup('/dco/pmg/prj/PRJ305P01', param, {width:0, height:0})
				// .then(res => {})
				// .catch(err => {})
				;
		},

	}
}
</script>